function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.5,
    width: 30,
    height: 15,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5v15h30V7.5H0Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 13.323 3.354 7.5 0 7.5 0 9.177 11.645 15 0 20.823 0 22.5 3.354 22.5 15 16.677 26.646 22.5 30 22.5 30 20.823 18.355 15 30 9.177 30 7.5 26.646 7.5 15 13.323",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 13.882 2.236 7.5 0 7.5 0 8.618 12.764 15 0 21.382 0 22.5 2.236 22.5 15 16.118 27.764 22.5 30 22.5 30 21.382 17.236 15 30 8.618 30 7.5 27.764 7.5 15 13.882",
    style: {
      fill: "#c8102e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.5 12.5 17.5 7.5 12.5 7.5 12.5 12.5 0 12.5 0 17.5 12.5 17.5 12.5 22.5 17.5 22.5 17.5 17.5 30 17.5 30 12.5 17.5 12.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.5 22.5 13.5 22.5 13.5 16.5 0 16.5 0 13.5 13.5 13.5 13.5 7.5 16.5 7.5 16.5 13.5 30 13.5 30 16.5 16.5 16.5 16.5 22.5",
    style: {
      fill: "#c8102e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/GB.8247823436e03af95f11f81160d41b6f.svg";
export { ForwardRef as ReactComponent };